const allFonts = {
    "SourceSansPro-Light": "SourceSansPro/SourceSansPro-Light.ttf",
    "SourceSansPro-Regular": "SourceSansPro/SourceSansPro-Regular.ttf",
    "SourceSansPro-SemiBold": "SourceSansPro/SourceSansPro-SemiBold.ttf",
    "SourceSansPro-Black": "SourceSansPro/SourceSansPro-Black.ttf",

    "SourceSansPro-LightItalic": "SourceSansPro/SourceSansPro-LightItalic.ttf",
    "SourceSansPro-Italic": "SourceSansPro/SourceSansPro-Italic.ttf",
    "SourceSansPro-SemiBoldItalic":
        "SourceSansPro/SourceSansPro-SemiBoldItalic.ttf",
    "SourceSansPro-BlackItalic": "SourceSansPro/SourceSansPro-BlackItalic.ttf",

    "BebasNeue Book": "BebasNeue/BebasNeue Book.otf",
    "BebasNeue Regular": "BebasNeue/BebasNeue Regular.otf",
    "BebasNeue Bold": "BebasNeue/BebasNeue Bold.otf",

    "RobotoSlab-Thin": "RobotoSlab/RobotoSlab-Thin.ttf",
    "RobotoSlab-Light": "RobotoSlab/RobotoSlab-Light.ttf",
    "RobotoSlab-Regular": "RobotoSlab/RobotoSlab-Regular.ttf",
    "RobotoSlab-Bold": "RobotoSlab/RobotoSlab-Bold.ttf",

    "Roboto-Light": "Roboto/Roboto-Light.ttf",
    "Roboto-Regular": "Roboto/Roboto-Regular.ttf",
    "Roboto-Bold": "Roboto/Roboto-Bold.ttf",
    "Roboto-Black": "Roboto/Roboto-Black.ttf",

    "Roboto-LightItalic": "Roboto/Roboto-LightItalic.ttf",
    "Roboto-Italic": "Roboto/Roboto-Italic.ttf",
    "Roboto-BoldItalic": "Roboto/Roboto-BoldItalic.ttf",
    "Roboto-BlackItalic": "Roboto/Roboto-BlackItalic.ttf",

    Marker: "Marker/TragicMarker.otf",

    "PlayfairDisplay-Regular": "PlayfairDisplay/PlayfairDisplay-Regular.ttf",
    "PlayfairDisplay-Black": "PlayfairDisplay/PlayfairDisplay-Black.ttf",

    "PlayfairDisplay-Italic": "PlayfairDisplay/PlayfairDisplay-Italic.ttf",
    "PlayfairDisplay-BlackItalic":
        "PlayfairDisplay/PlayfairDisplay-BlackItalic.ttf",

    "Raleway-Regular": "Raleway/Raleway-Regular.ttf",
    "Raleway-Medium": "Raleway/Raleway-Medium.ttf",
    "Raleway-SemiBold": "Raleway/Raleway-SemiBold.ttf",
    "Raleway-Bold": "Raleway/Raleway-Bold.ttf",
    "Raleway-ExtraBold": "Raleway/Raleway-ExtraBold.ttf",
    "Raleway-Black": "Raleway/Raleway-Black.ttf",

    "Raleway-Italic": "Raleway/Raleway-Italic.ttf",
    "Raleway-MediumItalic": "Raleway/Raleway-MediumItalic.ttf",
    "Raleway-SemiBoldItalic": "Raleway/Raleway-SemiBoldItalic.ttf",
    "Raleway-BoldItalic": "Raleway/Raleway-BoldItalic.ttf",
    "Raleway-ExtraBoldItalic": "Raleway/Raleway-ExtraBoldItalic.ttf",
    "Raleway-BlackItalic": "Raleway/Raleway-BlackItalic.ttf",

    "Montserrat-Thin": "Montserrat/Montserrat-Thin.ttf",
    "Montserrat-ExtraLight": "Montserrat/Montserrat-ExtraLight.ttf",
    "Montserrat-Light": "Montserrat/Montserrat-Light.ttf",
    "Montserrat-Regular": "Montserrat/Montserrat-Regular.ttf",
    "Montserrat-Medium": "Montserrat/Montserrat-Medium.ttf",
    "Montserrat-SemiBold": "Montserrat/Montserrat-SemiBold.ttf",
    "Montserrat-Bold": "Montserrat/Montserrat-Bold.ttf",
    "Montserrat-ExtraBold": "Montserrat/Montserrat-ExtraBold.ttf",
    "Montserrat-Black": "Montserrat/Montserrat-Black.ttf",

    "Montserrat-ThinItalic": "Montserrat/Montserrat-ThinItalic.ttf",
    "Montserrat-ExtraLightItalic": "Montserrat/Montserrat-ExtraLightItalic.ttf",
    "Montserrat-LightItalic": "Montserrat/Montserrat-LightItalic.ttf",
    "Montserrat-Italic": "Montserrat/Montserrat-Italic.ttf",
    "Montserrat-MediumItalic": "Montserrat/Montserrat-MediumItalic.ttf",
    "Montserrat-SemiBoldItalic": "Montserrat/Montserrat-SemiBoldItalic.ttf",
    "Montserrat-BoldItalic": "Montserrat/Montserrat-BoldItalic.ttf",
    "Montserrat-ExtraBoldItalic": "Montserrat/Montserrat-ExtraBoldItalic.ttf",
    "Montserrat-BlackItalic": "Montserrat/Montserrat-BlackItalic.ttf"
};

const headerFonts = [
    {
        type: "header",
        font: "sourcesanspro-header-heavy",
        weight: "heavy",
        label: "Source Sans Pro - Heavy"
    },
    {
        type: "header",
        font: "sourcesanspro-header-light",
        weight: "light",
        label: "Source Sans Pro - Light"
    },
    {
        type: "header",
        font: "bebasneue-header-heavy",
        weight: "heavy",
        label: "Bebas Neue - Heavy"
    },
    {
        type: "header",
        font: "bebasneue-header-light",
        weight: "light",
        label: "Bebas Neue - Light"
    },
    {
        type: "header",
        font: "playfair-header-heavy",
        weight: "heavy",
        label: "Playfair - Heavy"
    },
    {
        type: "header",
        font: "playfair-header-light",
        weight: "light",
        label: "Playfair - Light"
    },
    {
        type: "header",
        font: "raleway-header-heavy",
        weight: "heavy",
        label: "Raleway - Heavy"
    },
    {
        type: "header",
        font: "raleway-header-light",
        weight: "light",
        label: "Raleway - Light"
    },
    {
        type: "header",
        font: "montserrat-header-heavy",
        weight: "heavy",
        label: "Montserrat - Heavy"
    },
    {
        type: "header",
        font: "montserrat-header-light",
        weight: "light",
        label: "Montserrat - Light"
    },
    {
        type: "header",
        font: "roboto-header-heavy",
        weight: "heavy",
        label: "Roboto - Heavy"
    },
    {
        type: "header",
        font: "roboto-header-light",
        weight: "light",
        label: "Roboto - Light"
    },
    {
        type: "header",
        font: "robotoslab-header-heavy",
        weight: "heavy",
        label: "Roboto Slab - Heavy"
    },
    {
        type: "header",
        font: "robotoslab-header-light",
        weight: "light",
        label: "Roboto Slab - Light"
    }
];
const titleFonts = [
    {
        type: "title",
        font: "sourcesanspro-title-heavy",
        weight: "heavy",
        label: "Source Sans Pro - Heavy",
        url: allFonts["SourceSansPro-SemiBold"]
    },
    {
        type: "title",
        font: "sourcesanspro-title-light",
        weight: "light",
        label: "Source Sans Pro - Light",
        url: allFonts["SourceSansPro-Regular"]
    },
    {
        type: "title",
        font: "bebasneue-title-heavy",
        weight: "heavy",
        label: "Bebas Neue - Heavy",
        url: allFonts["BebasNeue Bold"]
    },
    {
        type: "title",
        font: "bebasneue-title-light",
        weight: "light",
        label: "Bebas Neue - Light",
        url: allFonts["BebasNeue Regular"]
    },
    {
        type: "title",
        font: "playfair-title-heavy",
        weight: "heavy",
        label: "Playfair - Heavy",
        url: allFonts["PlayfairDisplay-Black"]
    },
    {
        type: "title",
        font: "playfair-title-light",
        weight: "light",
        label: "Playfair - Light",
        url: allFonts["PlayfairDisplay-Regular"]
    },
    {
        type: "title",
        font: "raleway-title-heavy",
        weight: "heavy",
        label: "Raleway - Heavy",
        url: allFonts["Raleway-Bold"]
    },
    {
        type: "title",
        font: "raleway-title-light",
        weight: "light",
        label: "Raleway - Light",
        url: allFonts["Raleway-Regular"]
    },
    {
        type: "title",
        font: "montserrat-title-heavy",
        weight: "heavy",
        label: "Montserrat - Heavy",
        url: allFonts["Montserrat-Bold"]
    },
    {
        type: "title",
        font: "montserrat-title-light",
        weight: "light",
        label: "Montserrat - Light",
        url: allFonts["Montserrat-Regular"]
    },
    {
        type: "title",
        font: "roboto-title-heavy",
        weight: "heavy",
        label: "Roboto - Heavy",
        url: allFonts["Roboto-Bold"]
    },
    {
        type: "title",
        font: "roboto-title-light",
        weight: "light",
        label: "Roboto - Light",
        url: allFonts["Roboto-Regular"]
    },
    {
        type: "title",
        font: "robotoslab-title-heavy",
        weight: "heavy",
        label: "Roboto Slab - Heavy",
        url: allFonts["RobotoSlab-Bold"]
    },
    {
        type: "title",
        font: "robotoslab-title-light",
        weight: "light",
        label: "Roboto Slab - Light",
        url: allFonts["RobotoSlab-Regular"]
    }
];

const bodyFonts = [
    {
        type: "body",
        font: "sourcesanspro-body",
        label: "Source Sans Pro",
        url: allFonts["SourceSansPro-Regular"]
    },
    {
        type: "body",
        font: "raleway-body",
        label: "Raleway",
        url: allFonts["Raleway-Regular"]
    },
    {
        type: "body",
        font: "montserrat-body",
        label: "Montserrat",
        url: allFonts["Montserrat-Regular"]
    },
    {
        type: "body",
        font: "roboto-body",
        label: "Roboto",
        url: allFonts["Roboto-Regular"]
    },
    {
        type: "body",
        font: "robotoslab-body",
        label: "Roboto Slab",
        url: allFonts["RobotoSlab-Regular"]
    }
];

const minimalThemeHeaderProps = {
    fontHeader: "sourcesanspro-header-heavy",
    fontHeaderEmphasized: "SourceSansPro-SemiBold",
    fontHeaderEmphasizedItalic: "SourceSansPro-SemiBoldItalic",
    fontHeaderItalic: "SourceSansPro-SemiBoldItalic",
    fontHeaderLetterSpacing: 0,
    fontHeaderLineHeight: 1.6,
    fontHeaderRegular: "SourceSansPro-SemiBold",
    fontHeaderScaling: 100,
    fontHeaderTextTransform: "auto"
};
const minimalThemeTitleProps = {
    fontTitle: "sourcesanspro-title-heavy",
    fontTitleEmphasized: "SourceSansPro-SemiBold",
    fontTitleEmphasizedItalic: "SourceSansPro-SemiBoldItalic",
    fontTitleItalic: "SourceSansPro-SemiBoldItalic",
    fontTitleLetterSpacing: 0,
    fontTitleLineHeight: 1.6,
    fontTitleRegular: "SourceSansPro-SemiBold",
    fontTitleScaling: 100,
    fontTitleTextTransform: "auto"
};
const minimalThemeBodyProps = {
    fontBody: "sourcesanspro-body",
    fontBodyEmphasized: "SourceSansPro-SemiBold",
    fontBodyEmphasizedItalic: "SourceSansPro-SemiBoldItalic",
    fontBodyItalic: "SourceSansPro-Italic",
    fontBodyLetterSpacing: 0,
    fontBodyLineHeight: 1.9,
    fontBodyRegular: "SourceSansPro-Regular",
    fontBodyScaling: 100,
    fontBodyTextTransform: "auto"
};

const allBuiltInFontFamilies = []
    .concat(headerFonts, titleFonts, bodyFonts)
    .reduce((acc, val) => {
        acc[val.font] = val;
        return acc;
    }, {});

const CJK = {
    jp: "Noto/NotoSansCJKjp",
    kr: "Noto/NotoSansCJKkr",
    sc: "Noto/NotoSansCJKsc",
    tc: "Noto/NotoSansCJKtc"
};

const fallbackRanges = {
    "0": {
        end: "001F",
        name: "Control character",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "20": {
        end: "007F",
        name: "Basic Latin",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "80": {
        end: "00FF",
        name: "Latin-1 Supplement",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "100": {
        end: "017F",
        name: "Latin Extended-A",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "180": {
        end: "024F",
        name: "Latin Extended-B",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "250": {
        end: "02AF",
        name: "IPA Extensions",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "2B0": {
        end: "02FF",
        name: "Spacing Modifier Letters",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    // "300": {end: "036F", name: "Combining Diacritical Marks", hasBold: true, path: "Noto/NotoSans"},
    "370": {
        end: "03FF",
        name: "Greek and Coptic",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "400": {
        end: "04FF",
        name: "Cyrillic",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "500": {
        end: "052F",
        name: "Cyrillic Supplement",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "530": {
        end: "058F",
        name: "Armenian",
        hasBold: true,
        path: "Noto/NotoSansArmenian"
    },
    "590": {
        end: "05FF",
        name: "Hebrew",
        hasBold: true,
        path: "Noto/NotoSansHebrew"
    },
    "600": {
        end: "06FF",
        name: "Arabic",
        hasBold: true,
        path: "Noto/NotoSansArabic"
    },
    "700": { end: "074F", name: "Syriac", path: "Noto/NotoSansSyriacEastern" },
    "750": {
        end: "077F",
        name: "Arabic Supplement",
        hasBold: true,
        path: "Noto/NotoSansArabic"
    },
    "780": {
        end: "07BF",
        name: "Thaana",
        hasBold: true,
        path: "Noto/NotoSansThaana"
    },
    "7C0": { end: "07FF", name: "NKo", path: "Noto/NotoSansNKo" },
    "800": { end: "083F", name: "Samaritan", path: "Noto/NotoSansSamaritan" },
    "840": { end: "085F", name: "Mandaic", path: "Noto/NotoSansMandaic" },
    // "860": {end: "086F", name: "Syriac Supplement", path: "Noto/NotoSansSyriacEastern"},
    "8A0": {
        end: "08FF",
        name: "Arabic Extended-A",
        hasBold: true,
        path: "Noto/NotoSansArabic"
    },
    "900": {
        end: "097F",
        name: "Devanagari",
        hasBold: true,
        path: "Noto/NotoSansDevanagari"
    },
    "980": {
        end: "09FF",
        name: "Bengali",
        hasBold: true,
        path: "Noto/NotoSansBengali"
    },
    A00: {
        end: "0A7F",
        name: "Gurmukhi",
        hasBold: true,
        path: "Noto/NotoSansGurmukhi"
    },
    A80: {
        end: "0AFF",
        name: "Gujarati",
        hasBold: true,
        path: "Noto/NotoSansGujarati"
    },
    B00: {
        end: "0B7F",
        name: "Oriya",
        hasBold: true,
        path: "Noto/NotoSansOriya"
    },
    B80: {
        end: "0BFF",
        name: "Tamil",
        hasBold: true,
        path: "Noto/NotoSansTamil"
    },
    C00: {
        end: "0C7F",
        name: "Telugu",
        hasBold: true,
        path: "Noto/NotoSansTelugu"
    },
    C80: {
        end: "0CFF",
        name: "Kannada",
        hasBold: true,
        path: "Noto/NotoSansKannada"
    },
    D00: {
        end: "0D7F",
        name: "Malayalam",
        hasBold: true,
        path: "Noto/NotoSansMalayalam"
    },
    D80: {
        end: "0DFF",
        name: "Sinhala",
        hasBold: true,
        path: "Noto/NotoSansSinhala"
    },
    E00: {
        end: "0E7F",
        name: "Thai",
        hasBold: true,
        path: "Noto/NotoSansThai"
    },
    E80: { end: "0EFF", name: "Lao", hasBold: true, path: "Noto/NotoSansLao" },
    F00: {
        end: "0FFF",
        name: "Tibetan",
        hasBold: true,
        path: "Noto/NotoSansTibetan"
    },
    "1000": {
        end: "109F",
        name: "Myanmar",
        hasBold: true,
        path: "Noto/NotoSansMyanmar"
    },
    "10A0": {
        end: "10FF",
        name: "Georgian",
        hasBold: true,
        path: "Noto/NotoSansGeorgian"
    },
    "1100": {
        end: "11FF",
        name: "Hangul Jamo",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "1200": {
        end: "137F",
        name: "Ethiopic",
        hasBold: true,
        path: "Noto/NotoSansEthiopic"
    },
    "1380": {
        end: "139F",
        name: "Ethiopic Supplement",
        hasBold: true,
        path: "Noto/NotoSansEthiopic"
    },
    "13A0": {
        end: "13FF",
        name: "Cherokee",
        hasBold: true,
        path: "Noto/NotoSansCherokee"
    },
    "1400": {
        end: "167F",
        name: "Unified Canadian Aboriginal Syllabics",
        path: "Noto/NotoSansCanadianAboriginal"
    },
    "1680": { end: "169F", name: "Ogham", path: "Noto/NotoSansOgham" },
    "16A0": { end: "16FF", name: "Runic", path: "Noto/NotoSansRunic" },
    "1700": { end: "171F", name: "Tagalog", path: "Noto/NotoSansTagalog" },
    "1720": { end: "173F", name: "Hanunoo", path: "Noto/NotoSansHanunoo" },
    "1740": { end: "175F", name: "Buhid", path: "Noto/NotoSansBuhid" },
    "1760": { end: "177F", name: "Tagbanwa", path: "Noto/NotoSansTagbanwa" },
    "1780": {
        end: "17FF",
        name: "Khmer",
        hasBold: true,
        path: "Noto/NotoSansKhmer"
    },
    "1800": { end: "18AF", name: "Mongolian", path: "Noto/NotoSansMongolian" },
    "18B0": {
        end: "18FF",
        name: "Unified Canadian Aboriginal Syllabics Extended",
        path: "Noto/NotoSansCanadianAboriginal"
    },
    "1900": { end: "194F", name: "Limbu", path: "Noto/NotoSansLimbu" },
    "1950": { end: "197F", name: "Tai Le", path: "Noto/NotoSansTaiLe" },
    "1980": {
        end: "19DF",
        name: "New Tai Lue",
        path: "Noto/NotoSansNewTaiLue"
    },
    "19E0": {
        end: "19FF",
        name: "Khmer Symbols",
        hasBold: true,
        path: "Noto/NotoSansKhmer"
    },
    "1A00": { end: "1A1F", name: "Buginese", path: "Noto/NotoSansBuginese" },
    "1A20": { end: "1AAF", name: "Tai Tham", path: "Noto/NotoSansTaiTham" },
    // "1AB0": {end: "1AFF", name: "Combining Diacritical Marks Extended", hasBold: true, path: "Noto/NotoSans"},
    "1B00": { end: "1B7F", name: "Balinese", path: "Noto/NotoSansBalinese" },
    "1B80": { end: "1BBF", name: "Sundanese", path: "Noto/NotoSansSundanese" },
    "1BC0": { end: "1BFF", name: "Batak", path: "Noto/NotoSansBatak" },
    "1C00": { end: "1C4F", name: "Lepcha", path: "Noto/NotoSansLepcha" },
    "1C50": { end: "1C7F", name: "Ol Chiki", path: "Noto/NotoSansOlChiki" },
    "1C80": {
        end: "1C8F",
        name: "Cyrillic Extended C",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "1CC0": {
        end: "1CCF",
        name: "Sundanese Supplement",
        path: "Noto/NotoSansSundanese"
    },
    "1CD0": {
        end: "1CFF",
        name: "Vedic Extensions",
        hasBold: true,
        path: "Noto/NotoSansDevanagari"
    },
    "1D00": {
        end: "1D7F",
        name: "Phonetic Extensions",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "1D80": {
        end: "1DBF",
        name: "Phonetic Extensions Supplement",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    // "1DC0": {end: "1DFF", name: "Combining Diacritical Marks Supplement", hasBold: true, path: "Noto/NotoSans"},
    "1E00": {
        end: "1EFF",
        name: "Latin Extended Additional",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "1F00": {
        end: "1FFF",
        name: "Greek Extended",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "2000": {
        end: "206F",
        name: "General Punctuation",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "2070": {
        end: "209F",
        name: "Superscripts and Subscripts",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "20A0": {
        end: "20CF",
        name: "Currency Symbols",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    // "20D0": {end: "20FF", name: "Combining Diacritical Marks for Symbols", hasBold: true, path: "Noto/NotoSans"},
    "2100": {
        end: "214F",
        name: "Letterlike Symbols",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    // "2150": {end: "218F", name: "Number Forms", hasBold: true, path: "Noto/NotoSans"},
    // "2190": {end: "21FF", name: "Arrows", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "2200": {end: "22FF", name: "Mathematical Operators", hasBold: true, path: "Noto/NotoSansSymbols"},
    "2300": {
        end: "23FF",
        name: "Miscellaneous Technical",
        hasBold: true,
        path: "Noto/NotoSansSymbols"
    },
    "2400": {
        end: "243F",
        name: "Control Pictures",
        path: "Noto/NotoSansSymbols2"
    },
    // "2440": {end: "245F", name: "Optical Character Recognition", path: "Noto/NotoSansSymbols2"},
    "2460": {
        end: "24FF",
        name: "Enclosed Alphanumerics",
        hasBold: true,
        path: "Noto/NotoSansSymbols"
    },
    "2500": {
        end: "257F",
        name: "Box Drawing",
        hasBold: true,
        path: "Noto/NotoSansMono"
    },
    "2580": {
        end: "259F",
        name: "Block Elements",
        hasBold: true,
        path: "Noto/NotoSansMono"
    },
    // "25A0": {end: "25FF", name: "Geometric Shapes", hasBold: true, path: "Noto/NotoSansSymbols"},
    "2600": {
        end: "26FF",
        name: "Miscellaneous Symbols",
        hasBold: true,
        path: "Noto/NotoSansSymbols"
    }, // needs Symbols2 to fill range
    // "2700": {end: "27BF", name: "Dingbats", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "27C0": {end: "27EF", name: "Miscellaneous Mathematical Symbols-A", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "27F0": {end: "27FF", name: "Supplemental Arrows-A", hasBold: true, path: "Noto/NotoSansSymbols"},
    "2800": {
        end: "28FF",
        name: "Braille Patterns",
        path: "Noto/NotoSansSymbols2"
    },
    // "2900": {end: "297F", name: "Supplemental Arrows-B", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "2980": {end: "29FF", name: "Miscellaneous Mathematical Symbols-B", path: "Noto/NotoSansSymbols2"},
    // "2A00": {end: "2AFF", name: "Supplemental Mathematical Operators", hasBold: true, path: "Noto/NotoSansSymbols"},
    "2B00": {
        end: "2BFF",
        name: "Miscellaneous Symbols and Arrows",
        path: "Noto/NotoSansSymbols2"
    },
    "2C00": {
        end: "2C5F",
        name: "Glagolitic",
        path: "Noto/NotoSansGlagolitic"
    },
    "2C60": {
        end: "2C7F",
        name: "Latin Extended-C",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "2C80": { end: "2CFF", name: "Coptic", path: "Noto/NotoSansCoptic" },
    "2D00": {
        end: "2D2F",
        name: "Georgian Supplement",
        hasBold: true,
        path: "Noto/NotoSansGeorgian"
    },
    "2D30": { end: "2D7F", name: "Tifinagh", path: "Noto/NotoSansTifinagh" },
    "2D80": {
        end: "2DDF",
        name: "Ethiopic Extended",
        hasBold: true,
        path: "Noto/NotoSansEthiopic"
    },
    // "2DE0": {end: "2DFF", name: "Cyrillic Extended-A", hasBold: true, path: "Noto/NotoSans"},
    "2E00": {
        end: "2E7F",
        name: "Supplemental Punctuation",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    "2E80": {
        end: "2EFF",
        name: "CJK Radicals Supplement",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "2F00": {
        end: "2FDF",
        name: "Kangxi Radicals",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    // "2FF0": {end: "2FFF", name: "Ideographic Description Characters", hasBold: true, path: "Noto/NotoSans"},
    "3000": {
        end: "303F",
        name: "CJK Symbols and Punctuation",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3040": {
        end: "309F",
        name: "Hiragana",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "30A0": {
        end: "30FF",
        name: "Katakana",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3100": {
        end: "312F",
        name: "Bopomofo",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3130": {
        end: "318F",
        name: "Hangul Compatibility Jamo",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3190": {
        end: "319F",
        name: "Kanbun",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "31A0": {
        end: "31BF",
        name: "Bopomofo Extended",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "31C0": {
        end: "31EF",
        name: "CJK Strokes",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "31F0": {
        end: "31FF",
        name: "Katakana Phonetic Extensions",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3200": {
        end: "32FF",
        name: "Enclosed CJK Letters and Months",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3300": {
        end: "33FF",
        name: "CJK Compatibility",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "3400": {
        end: "4DBF",
        name: "CJK Unified Ideographs Extension A",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    "4DC0": {
        end: "4DFF",
        name: "Yijing Hexagram Symbols",
        path: "Noto/NotoSansSymbols2"
    },
    "4E00": {
        end: "9FFF",
        name: "CJK Unified Ideographs",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    A000: { end: "A48F", name: "Yi Syllables", path: "Noto/NotoSansYi" },
    A490: { end: "A4CF", name: "Yi Radicals", path: "Noto/NotoSansYi" },
    A4D0: { end: "A4FF", name: "Lisu", path: "Noto/NotoSansLisu" },
    A500: { end: "A63F", name: "Vai", path: "Noto/NotoSansVai" },
    A640: {
        end: "A69F",
        name: "Cyrillic Extended-B",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    A6A0: { end: "A6FF", name: "Bamum", path: "Noto/NotoSansBamum" },
    A700: {
        end: "A71F",
        name: "Modifier Tone Letters",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    A720: {
        end: "A7FF",
        name: "Latin Extended-D",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    A800: {
        end: "A82F",
        name: "Syloti Nagri",
        path: "Noto/NotoSansSylotiNagri"
    },
    A830: {
        end: "A83F",
        name: "Common Indic Number Forms",
        hasBold: true,
        path: "Noto/NotoSansDevanagari"
    },
    A840: { end: "A87F", name: "Phags-pa", path: "Noto/NotoSansPhagsPa" },
    A880: { end: "A8DF", name: "Saurashtra", path: "Noto/NotoSansSaurashtra" },
    A8E0: {
        end: "A8FF",
        name: "Devanagari Extended",
        hasBold: true,
        path: "Noto/NotoSansDevanagari"
    },
    A900: { end: "A92F", name: "Kayah Li", path: "Noto/NotoSansKayahLi" },
    A930: { end: "A95F", name: "Rejang", path: "Noto/NotoSansRejang" },
    A960: {
        end: "A97F",
        name: "Hangul Jamo Extended-A",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    A980: { end: "A9DF", name: "Javanese", path: "Noto/NotoSansJavanese" },
    A9E0: {
        end: "A9FF",
        name: "Myanmar Extended-B",
        hasBold: true,
        path: "Noto/NotoSansMyanmar"
    },
    AA00: {
        end: "AA5F",
        name: "Cham",
        hasBold: true,
        path: "Noto/NotoSansCham"
    },
    AA60: {
        end: "AA7F",
        name: "Myanmar Extended-A",
        hasBold: true,
        path: "Noto/NotoSansMyanmar"
    },
    AA80: { end: "AADF", name: "Tai Viet", path: "Noto/NotoSansTaiViet" },
    AAE0: {
        end: "AAFF",
        name: "Meetei Mayek Extensions",
        path: "Noto/NotoSansMeeteiMayek"
    },
    AB00: {
        end: "AB2F",
        name: "Ethiopic Extended-A",
        hasBold: true,
        path: "Noto/NotoSansEthiopic"
    },
    AB30: {
        end: "AB6F",
        name: "Latin Extended-E",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    AB70: {
        end: "ABBF",
        name: "Cherokee Supplement",
        hasBold: true,
        path: "Noto/NotoSansCherokee"
    },
    ABC0: {
        end: "ABFF",
        name: "Meetei Mayek",
        path: "Noto/NotoSansMeeteiMayek"
    },
    AC00: {
        end: "D7AF",
        name: "Hangul Syllables",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    D7B0: {
        end: "D7FF",
        name: "Hangul Jamo Extended-B",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    // "D800": {end: "DB7F", name: "High Surrogates", hasBold: true, path: "Noto/NotoSans"},
    // "DB80": {end: "DBFF", name: "High Private Use Surrogates", hasBold: true, path: "Noto/NotoSans"},
    // "DC00": {end: "DFFF", name: "Low Surrogates", hasBold: true, path: "Noto/NotoSans"},
    // "E000": {end: "F8FF", name: "Private Use Area", hasBold: true, path: "Noto/NotoSans"},
    F900: {
        end: "FAFF",
        name: "CJK Compatibility Ideographs",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    FB00: {
        end: "FB4F",
        name: "Alphabetic Presentation Forms",
        hasBold: true,
        path: "Noto/NotoSans"
    },
    FB50: {
        end: "FDFF",
        name: "Arabic Presentation Forms-A",
        hasBold: true,
        path: "Noto/NotoSansArabic"
    },
    // "FE00": {end: "FE0F", name: "Variation Selectors", hasBold: true, path: "Noto/NotoSans"},
    FE10: {
        end: "FE1F",
        name: "Vertical Forms",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    // "FE20": {end: "FE2F", name: "Combining Half Marks", hasBold: true, path: "Noto/NotoSans"},
    FE30: {
        end: "FE4F",
        name: "CJK Compatibility Forms",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    FE50: {
        end: "FE6F",
        name: "Small Form Variants",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    FE70: {
        end: "FEFF",
        name: "Arabic Presentation Forms-B",
        hasBold: true,
        path: "Noto/NotoSansArabic"
    },
    FF00: {
        end: "FFEF",
        name: "Halfwidth and Fullwidth Forms",
        path: CJK,
        hasBold: true,
        isCJK: true
    },
    // "FFF0": {end: "FFFF", name: "Specials", path: "Noto/NotoSansSymbols2"},
    "10000": { end: true }
    // "10000": {end: "1007F", name: "Linear B Syllabary", path: "Noto/NotoSansLinearB"},
    // "10080": {end: "100FF", name: "Linear B Ideograms", path: "Noto/NotoSansLinearB"},
    // "10100": {end: "1013F", name: "Aegean Numbers", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "10140": {end: "1018F", name: "Ancient Greek Numbers", hasBold: true, path: "Noto/NotoSans"},
    // "10190": {end: "101CF", name: "Ancient Symbols", hasBold: true, path: "Noto/NotoSans"},
    // "101D0": {end: "101FF", name: "Phaistos Disc", hasBold: true, path: "Noto/NotoSans"},
    // "10280": {end: "1029F", name: "Lycian", path: "Noto/NotoSansLycian"},
    // "102A0": {end: "102DF", name: "Carian", path: "Noto/NotoSansCarian"},
    // "102E0": {end: "102FF", name: "Coptic Epact Numbers", path: "Noto/NotoSansCoptic"},
    // "10300": {end: "1032F", name: "Old Italic", path: "Noto/NotoSansOldItalic"},
    // "10330": {end: "1034F", name: "Gothic", path: "Noto/NotoSansGothic"},
    // "10350": {end: "1037F", name: "Old Permic", hasBold: true, path: "Noto/NotoSans"},
    // "10380": {end: "1039F", name: "Ugaritic", path: "Noto/NotoSansUgaritic"},
    // "103A0": {end: "103DF", name: "Old Persian", path: "Noto/NotoSansOldPersian"},
    // "10400": {end: "1044F", name: "Deseret", path: "Noto/NotoSansDeseret"},
    // "10450": {end: "1047F", name: "Shavian", path: "Noto/NotoSansShavian"},
    // "10480": {end: "104AF", name: "Osmanya", path: "Noto/NotoSansOsmanya"},
    // "104B0": {end: "104FF", name: "Osage", path: "Noto/NotoSansOsage"},
    // "10500": {end: "1052F", name: "Elbasan", hasBold: true, path: "Noto/NotoSans"},
    // "10530": {end: "1056F", name: "Caucasian Albanian", hasBold: true, path: "Noto/NotoSans"},
    // "10600": {end: "1077F", name: "Linear A", hasBold: true, path: "Noto/NotoSans"},
    // "10800": {end: "1083F", name: "Cypriot Syllabary", path: "Noto/NotoSansCypriot"},
    // "10840": {end: "1085F", name: "Imperial Aramaic", path: "Noto/NotoSansImperialAramaic"},
    // "10860": {end: "1087F", name: "Palmyrene", hasBold: true, path: "Noto/NotoSans"},
    // "10880": {end: "108AF", name: "Nabataean", hasBold: true, path: "Noto/NotoSans"},
    // "108E0": {end: "108FF", name: "Hatran", hasBold: true, path: "Noto/NotoSans"},
    // "10900": {end: "1091F", name: "Phoenician", path: "Noto/NotoSansPhoenician"},
    // "10920": {end: "1093F", name: "Lydian", path: "Noto/NotoSansLydian"},
    // "10980": {end: "1099F", name: "Meroitic Hieroglyphs", hasBold: true, path: "Noto/NotoSans"},
    // "109A0": {end: "109FF", name: "Meroitic Cursive", hasBold: true, path: "Noto/NotoSans"},
    // "10A00": {end: "10A5F", name: "Kharoshthi", path: "Noto/NotoSansKharoshthi"},
    // "10A60": {end: "10A7F", name: "Old South Arabian", path: "Noto/NotoSansOldSouthArabian"},
    // "10A80": {end: "10A9F", name: "Old North Arabian", path: "Noto/NotoSansOldSouthArabian"},
    // "10AC0": {end: "10AFF", name: "Manichaean", hasBold: true, path: "Noto/NotoSans"},
    // "10B00": {end: "10B3F", name: "Avestan", path: "Noto/NotoSansAvestan"},
    // "10B40": {end: "10B5F", name: "Inscriptional Parthian", path: "Noto/NotoSansInscriptionalParthian"},
    // "10B60": {end: "10B7F", name: "Inscriptional Pahlavi", path: "Noto/NotoSansInscriptionalPahlavi"},
    // "10B80": {end: "10BAF", name: "Psalter Pahlavi", hasBold: true, path: "Noto/NotoSans"},
    // "10C00": {end: "10C4F", name: "Old Turkic", path: "Noto/NotoSansOldTurkic"},
    // "10C80": {end: "10CFF", name: "Old Hungarian", hasBold: true, path: "Noto/NotoSans"},
    // "10E60": {end: "10E7F", name: "Rumi Numeral Symbols", hasBold: true, path: "Noto/NotoSans"},
    // "11000": {end: "1107F", name: "Brahmi", path: "Noto/NotoSansBrahmi"},
    // "11080": {end: "110CF", name: "Kaithi", path: "Noto/NotoSansKaithi"},
    // "110D0": {end: "110FF", name: "Sora Sompeng", hasBold: true, path: "Noto/NotoSans"},
    // "11100": {end: "1114F", name: "Chakma", path: "Noto/NotoSansChakma"},
    // "11150": {end: "1117F", name: "Mahajani", hasBold: true, path: "Noto/NotoSans"},
    // "11180": {end: "111DF", name: "Sharada", hasBold: true, path: "Noto/NotoSans"},
    // "111E0": {end: "111FF", name: "Sinhala Archaic Numbers", hasBold: true, path: "Noto/NotoSansSinhala"},
    // "11200": {end: "1124F", name: "Khojki", hasBold: true, path: "Noto/NotoSans"},
    // "11280": {end: "112AF", name: "Multani", hasBold: true, path: "Noto/NotoSans"},
    // "112B0": {end: "112FF", name: "Khudawadi", hasBold: true, path: "Noto/NotoSans"},
    // "11300": {end: "1137F", name: "Grantha", hasBold: true, path: "Noto/NotoSans"},
    // "11400": {end: "1147F", name: "Newa", hasBold: true, path: "Noto/NotoSans"},
    // "11480": {end: "114DF", name: "Tirhuta", hasBold: true, path: "Noto/NotoSans"},
    // "11580": {end: "115FF", name: "Siddham", hasBold: true, path: "Noto/NotoSans"},
    // "11600": {end: "1165F", name: "Modi", hasBold: true, path: "Noto/NotoSans"},
    // "11660": {end: "1167F", name: "Mongolian Supplement", path: "Noto/NotoSansMongolian"},
    // "11680": {end: "116CF", name: "Takri", hasBold: true, path: "Noto/NotoSans"},
    // "11700": {end: "1173F", name: "Ahom", hasBold: true, path: "Noto/NotoSans"},
    // "118A0": {end: "118FF", name: "Warang Citi", hasBold: true, path: "Noto/NotoSans"},
    // "11A00": {end: "11A4F", name: "Zanabazar Square", hasBold: true, path: "Noto/NotoSans"},
    // "11A50": {end: "11AAF", name: "Soyombo", hasBold: true, path: "Noto/NotoSans"},
    // "11AC0": {end: "11AFF", name: "Pau Cin Hau", hasBold: true, path: "Noto/NotoSans"},
    // "11C00": {end: "11C6F", name: "Bhaiksuki", hasBold: true, path: "Noto/NotoSans"},
    // "11C70": {end: "11CBF", name: "Marchen", hasBold: true, path: "Noto/NotoSans"},
    // "11D00": {end: "11D5F", name: "Masaram Gondi", hasBold: true, path: "Noto/NotoSans"},
    // "12000": {end: "123FF", name: "Cuneiform", path: "Noto/NotoSansCuneiform"},
    // "12400": {end: "1247F", name: "Cuneiform Numbers and Punctuation", path: "Noto/NotoSansCuneiform"},
    // "12480": {end: "1254F", name: "Early Dynastic Cuneiform", path: "Noto/NotoSansCuneiform"},
    // "13000": {end: "1342F", name: "Egyptian Hieroglyphs", path: "Noto/NotoSansEgyptianHieroglyphs"},
    // "14400": {end: "1467F", name: "Anatolian Hieroglyphs", path: "Noto/NotoSansAnatolianHieroglyphs"},
    // "16800": {end: "16A3F", name: "Bamum Supplement", path: "Noto/NotoSansBamum"},
    // "16A40": {end: "16A6F", name: "Mro", hasBold: true, path: "Noto/NotoSans"},
    // "16AD0": {end: "16AFF", name: "Bassa Vah", hasBold: true, path: "Noto/NotoSans"},
    // "16B00": {end: "16B8F", name: "Pahawh Hmong", hasBold: true, path: "Noto/NotoSans"},
    // "16F00": {end: "16F9F", name: "Miao", hasBold: true, path: "Noto/NotoSans"},
    // "16FE0": {end: "16FFF", name: "Ideographic Symbols and Punctuation", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "17000": {end: "187FF", name: "Tangut", hasBold: true, path: "Noto/NotoSans"},
    // "18800": {end: "18AFF", name: "Tangut Components", hasBold: true, path: "Noto/NotoSans"},
    // "1B000": {end: "1B0FF", name: "Kana Supplement", path: CJK, hasBold: true, isCJK: true},
    // "1B100": {end: "1B12F", name: "Kana Extended-A", path: CJK, hasBold: true, isCJK: true},
    // "1B170": {end: "1B2FF", name: "Nushu", hasBold: true, path: "Noto/NotoSans"},
    // "1BC00": {end: "1BC9F", name: "Duployan", hasBold: true, path: "Noto/NotoSans"},
    // "1BCA0": {end: "1BCAF", name: "Shorthand Format Controls", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D000": {end: "1D0FF", name: "Byzantine Musical Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D100": {end: "1D1FF", name: "Musical Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D200": {end: "1D24F", name: "Ancient Greek Musical Notation", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D300": {end: "1D35F", name: "Tai Xuan Jing Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D360": {end: "1D37F", name: "Counting Rod Numerals", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D400": {end: "1D7FF", name: "Mathematical Alphanumeric Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1D800": {end: "1DAAF", name: "Sutton SignWriting", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1E000": {end: "1E02F", name: "Glagolitic Supplement", path: "Noto/NotoSansGlagolitic"},
    // "1E800": {end: "1E8DF", name: "Mende Kikakui", hasBold: true, path: "Noto/NotoSans"},
    // "1E900": {end: "1E95F", name: "Adlam", path: "Noto/NotoSansAdlam"},
    // "1EE00": {end: "1EEFF", name: "Arabic Mathematical Alphabetic Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F000": {end: "1F02F", name: "Mahjong Tiles", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F030": {end: "1F09F", name: "Domino Tiles", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F0A0": {end: "1F0FF", name: "Playing Cards", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F100": {end: "1F1FF", name: "Enclosed Alphanumeric Supplement", hasBold: true, path: "Noto/NotoSans"},
    // "1F200": {end: "1F2FF", name: "Enclosed Ideographic Supplement", hasBold: true, path: "Noto/NotoSans"},
    // "1F300": {end: "1F5FF", name: "Miscellaneous Symbols and Pictographs", path: "Noto/NotoSansSymbols2"},
    // "1F600": {end: "1F64F", name: "Emoticons (Emoji)", path: "Noto/NotoEmoji"},
    // "1F650": {end: "1F67F", name: "Ornamental Dingbats", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F680": {end: "1F6FF", name: "Transport and Map Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F700": {end: "1F77F", name: "Alchemical Symbols", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F780": {end: "1F7FF", name: "Geometric Shapes Extended", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F800": {end: "1F8FF", name: "Supplemental Arrows-C", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "1F900": {end: "1F9FF", name: "Supplemental Symbols and Pictographs", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "20000": {end: "2A6DF", name: "CJK Unified Ideographs Extension B", path: CJK, hasBold: true, isCJK: true},
    // "2A700": {end: "2B73F", name: "CJK Unified Ideographs Extension C", path: CJK, hasBold: true, isCJK: true},
    // "2B740": {end: "2B81F", name: "CJK Unified Ideographs Extension D", path: CJK, hasBold: true, isCJK: true},
    // "2B820": {end: "2CEAF", name: "CJK Unified Ideographs Extension E", path: CJK, hasBold: true, isCJK: true},
    // "2CEB0": {end: "2EBEF", name: "CJK Unified Ideographs Extension F", path: CJK, hasBold: true, isCJK: true},
    // "2F800": {end: "2FA1F", name: "CJK Compatibility Ideographs Supplement", path: CJK, hasBold: true, isCJK: true},
    // "E0000": {end: "E007F", name: "Tags", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "E0100": {end: "E01EF", name: "Variation Selectors Supplement", hasBold: true, path: "Noto/NotoSansSymbols"},
    // "E01F0": {end: true}
};

const rangeStartDecToHexMap = {};
const fallbackRangeStartsDecimal = Object.keys(fallbackRanges)
    .map(hex => {
        let int = parseInt(hex, 16);
        rangeStartDecToHexMap[int] = hex;
        return int;
    })
    .sort((a, b) => a - b);

const allUnicodeText = fallbackRangeStartsDecimal.map(decStart => {
    const start = decStart.toString(16).toUpperCase();
    const set = fallbackRanges[start];
    const end = set.end;
    const decEnd = parseInt(end, 16);

    let str = "";
    for (let i = decStart; i <= decEnd; i++) {
        str = str + String.fromCodePoint(i);
    }
    let path;
    if (set.isCJK) {
        path = "Chinese/Japanese/Korean";
    } else {
        path = set.path;
    }
    return {
        start,
        str,
        end: set.end,
        name: set.name,
        path
    };
});

function createUnicodeSlides() {
    return allUnicodeText.map(data => ({
        templateId: "text",
        data: {
            header: {
                title: { text: data.name },
                description: { text: data.start + " - " + data.end },
                label: { text: data.path }
            },
            primary: {
                blocks: [
                    {
                        content: { text: data.str.replace(/(.{5})/g, "$1 ") },
                        type: "body"
                    }
                ]
            }
        }
    }));
}

function compareTextTypes() {
    return allUnicodeText.map(data => {
        const fontDescription = `${data.name} - ${data.path}: ${data.start} - ${data.end}`;
        const headerText = `Header ${data.str.slice(
            data.str.length / 2 - 3,
            data.str.length / 2 + 3
        )} ${data.str.slice(data.str.length / 2 - 3, data.str.length / 2 + 3)}`;
        const displayText = `Display ${data.str.slice(
            data.str.length / 2 - 3,
            data.str.length / 2 + 3
        )}`;
        const titleText = `Title ${data.str.slice(
            data.str.length / 2 - 5,
            data.str.length / 2 + 5
        )}`;
        const bodyText = `Body ${(data.str.length < 100
            ? data.str
            : data.str.slice(data.str.length / 2 - 50, data.str.length / 2 + 50)
        ).replace(/(.{5})/g, "$1 ")}`;
        return {
            templateId: "collage",
            layout: {
                headerPosition: "top"
            },
            data: {
                header: {
                    title: {
                        text: headerText,
                        styles: [
                            {
                                bold: false,
                                start: 0,
                                end: 14
                            },
                            {
                                bold: true,
                                start: 14,
                                end: 21
                            }
                        ]
                    },
                    description: {
                        text: fontDescription,
                        styles: [
                            {
                                bold: false,
                                start: 0,
                                end: 74
                            }
                        ]
                    }
                },
                primary: {
                    showGutter: false,
                    fullBleed: true,
                    matchTextScale: true,
                    items: [
                        {
                            showText: true,
                            blocks: [
                                {
                                    type: "headline",
                                    content: {
                                        text: displayText,
                                        styles: [
                                            {
                                                bold: false,
                                                start: 0,
                                                end: 20
                                            }
                                        ]
                                    }
                                },
                                {
                                    type: "list",
                                    items: [
                                        {
                                            title: {
                                                text: titleText,
                                                styles: [
                                                    {
                                                        bold: false,
                                                        start: 0,
                                                        end: 20
                                                    }
                                                ]
                                            },
                                            body: {
                                                text: bodyText,
                                                styles: [
                                                    {
                                                        bold: false,
                                                        start: 0,
                                                        end: 130
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ],
                            cellColor: "background_light"
                        },
                        {
                            showText: true,
                            blocks: [
                                {
                                    type: "headline",
                                    content: {
                                        text: displayText,
                                        styles: [
                                            {
                                                bold: true,
                                                start: 0,
                                                end: 20
                                            }
                                        ]
                                    }
                                },
                                {
                                    type: "list",
                                    items: [
                                        {
                                            title: {
                                                text: titleText,
                                                styles: [
                                                    {
                                                        bold: true,
                                                        start: 0,
                                                        end: 20
                                                    }
                                                ]
                                            },
                                            body: {
                                                text: bodyText,
                                                styles: [
                                                    {
                                                        bold: true,
                                                        start: 0,
                                                        end: 130
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            ],
                            cellColor: "background_light"
                        }
                    ]
                }
            }
        };
    });
}

// find the start of the unicode range containing n.
function calculateFallbackRangeStart(n) {
    for (let i = 0; i < fallbackRangeStartsDecimal.length; i++) {
        if (
            n >= fallbackRangeStartsDecimal[i] &&
            n < fallbackRangeStartsDecimal[i + 1]
        ) {
            return rangeStartDecToHexMap[fallbackRangeStartsDecimal[i]];
        }
    }
    new Error(`no range for ${n}`);
}

module.exports = {
    allFonts,
    allBuiltInFontFamilies,
    headerFonts,
    minimalThemeHeaderProps,
    titleFonts,
    minimalThemeTitleProps,
    bodyFonts,
    minimalThemeBodyProps,
    fallbackRanges,
    calculateFallbackRangeStart
};
